import { ClassesView } from "../components/principal/ClassesView";

export const Classes = () => {
  return (
    <div>
      <ClassesView />
    </div>
  );
};
